module.exports = __webpack_public_path__ + "img/PG4-5-473x316.28a306f7.png";